import React, { useState } from 'react';
import cn from 'classnames';
import { FieldProps } from 'formik';

import style from './Checkbox.module.css';

type Props = {
  field: FieldProps['field'];
  form: FieldProps['form'];
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur?: (e: React.SyntheticEvent) => void;
};

function Checkbox({ form, field, handleChange, handleBlur }: Props): JSX.Element {
  const touched = form ? form.touched : {};
  const errors = form ? form.errors : {};
  const name = field ? field.name : '';
  const isError = touched[name] && errors[name];

  return (
    <div className={style.wrapper}>
      <label className={cn(style.container, field.value && style.blackLabel)} htmlFor="agree">
        {/* Я согласен(-на) на обработку персональных данных */}
        <div className={style.agree}>
          {' '}
          Я даю согласие на обработку <button>персональных данных</button>
        </div>
        <input
          {...field}
          type="checkbox"
          name="agree"
          checked={field.value || false}
          onChange={e => {
            field.onChange(e);
            handleChange && handleChange(e);
          }}
          onBlur={e => {
            field.onBlur(e);
            handleBlur && handleBlur(e);
          }}
          id="agree"
        />
        <span className={cn(style.checkmark, isError && style.errorCheckmark)}></span>
      </label>
      {isError && <div className={style.errorLabel}>{errors[name]}</div>}
    </div>
  );
}

export default Checkbox;
